// Slot Story: what the proxy's IU Rewrite did to a slot's GAM request, and the
// "USB capture cannot be rewritten" notice. Pure; never throws.
import { describeRewrite } from './describeRewrite';

export const REWRITE_LABEL = 'Rewritten in the request before send';
export const LOGCAT_REWRITE_NOTICE = 'This row came from USB capture. The proxy cannot rewrite USB traffic, so the rewrite rule did not change this request.';

// The LIVE row (rowsByKey), not lc.phases.gam.row: the projected echo does not carry iuRewrite.
export function gamRowForSlot(lc, rowsByKey) {
  try {
    const key = lc && lc.phases && lc.phases.gam && lc.phases.gam.rowKey;
    if (key == null || !rowsByKey || typeof rowsByKey.get !== 'function') return null;
    return rowsByKey.get(key) || null;
  } catch (e) {
    return null;
  }
}

export function rewriteLinesForSlot(lc, rowsByKey) {
  try {
    const live = gamRowForSlot(lc, rowsByKey);
    if (!live || live.captureSource === 'logcat') return [];
    return describeRewrite(live.iuRewrite);
  } catch (e) {
    return [];
  }
}

// Video (DAI stream card): the IMA stream-create row is the live row itself.
export function rewriteLinesForRow(row) {
  try {
    if (!row || row.captureSource === 'logcat') return [];
    return describeRewrite(row.iuRewrite);
  } catch (e) {
    return [];
  }
}

export function gamRuleActiveForRow(ruleState, live, extraIds = []) {
  try {
    if (!ruleState || ruleState.enabled !== true || !Array.isArray(ruleState.rules)) return false;
    const l = live || {};
    const ids = [l.deviceId, l.rawDeviceId, l.platformClass, l.clientKey, l._deviceTab, ...(Array.isArray(extraIds) ? extraIds : [])]
      .filter((d) => d != null)
      .map((d) => String(d).trim().toLowerCase());
    return ruleState.rules.some((rule) => {
      if (!rule || rule.enabled === false) return false;
      if (!(rule.targets && rule.targets.gam)) return false;
      if (!rule.device) return true;
      return ids.includes(String(rule.device).trim().toLowerCase());
    });
  } catch (e) {
    return false;
  }
}

export function logcatRewriteNotice(lc, rowsByKey, ruleState, deviceId) {
  try {
    const live = gamRowForSlot(lc, rowsByKey);
    if (!live || live.captureSource !== 'logcat') return null;
    return gamRuleActiveForRow(ruleState, live, [deviceId]) ? LOGCAT_REWRITE_NOTICE : null;
  } catch (e) {
    return null;
  }
}
